import { render, staticRenderFns } from "./ChipInput.vue?vue&type=template&id=77acdcf0&scoped=true"
import script from "./ChipInput.vue?vue&type=script&lang=js"
export * from "./ChipInput.vue?vue&type=script&lang=js"
import style0 from "./chip-input.scss?vue&type=style&index=0&id=77acdcf0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77acdcf0",
  null
  
)

export default component.exports